import {  createSlice } from "@reduxjs/toolkit";

const initialState = {
  expanded: null,
  activeEntityType:null,
  activeEntityTitle:null,
  mainMockId:null

};



export const drawerSlice = createSlice({
  name: "drawerSlice",
  initialState,
  reducers: {
    setExpanded: (state, action) => {
      state.expanded = action.payload;
    },
    setActiveEntityType: (state, action) => {
      state.activeEntityType = action.payload;
    },
    
    setActiveEntityTitle: (state, action) => {
      state.activeEntityTitle = action.payload;
    },
     setMainMockId: (state, action) => {
      state.mainMockId = action.payload;
    },
    resetDrawer:()=>initialState,
  },
  

});

export const { setExpanded, resetDrawer, setActiveEntityType, setActiveEntityTitle,setMainMockId } =
  drawerSlice.actions;

export default drawerSlice.reducer;
